import React, { useState } from 'react';
import axios from 'axios';
import WalletComponent from './WalletComponent'; // Assuming this is the component that will open on success

const Topup = ({ userDetails }) => {
  const [amount, setAmount] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // This function handles the form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || isNaN(amount) || amount <= 0) {
      setErrorMessage('Please enter a valid amount greater than 0');
      return;
    }

    try {
      // Replace this with the URL to your backend endpoint
      const response = await axios.post('https://sharedvision-partners.online/v1/API/topup.php', {
        email: userDetails?.email,
        amount: amount,
      }, {
        timeout: 10000,  // Optional: set timeout of 10 seconds
      });

      if (response.status === 200 && response.data.status === 'success') {
        setIsSuccess(true);
      } else {
        setErrorMessage(response.data.message || 'Error processing request');
      }
    } catch (error) {
      setErrorMessage('There was an error sending the request. Please try again.');
      console.error('Error sending data:', error);
    }
  };

  // Close handler for the WalletComponent
  const handleClose = () => {
    console.log('Closing wallet');
    setIsSuccess(false); // Optionally reset success state to allow reopening the form
  };

  return (
    <div style={styles.container}>
      {!isSuccess ? (
        <div style={styles.formContainer}>
          <h4> You can Top-up your account here</h4>
          <h2 style={styles.header}>Be USDT BEp20 ready</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.inputGroup}>
              <input
                type="hidden"
                value={userDetails?.email} // Just use this as the value
                readOnly
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Amount</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
                style={styles.input}
              />
            </div>
            {errorMessage && <p style={styles.errorMessage}>{errorMessage}</p>}
            <button type="submit" style={styles.submitButton}>
              Submit
            </button>
          </form>

          {/* Help Box */}
          <div style={styles.helpBox}>
            <p>If you need help with top-up, our bot will assist you:</p>
            <div style={styles.linkContainer}>
  <a href="https://t.me/+0WQkWfyFmGczMjdh" target="_blank" rel="noopener noreferrer" style={styles.link}><img className='icon'
              src="/tg.png" 
              alt="Telegram" 
              style={styles.icon} 
            />
  
  </a>
  <a href="https://whatsapp.com/channel/0029Vb4PrsFGehEO5SQZSb0E" target="_blank" rel="noopener noreferrer" style={styles.link}>
  <img className='icon'
              src="/whatApp.png" 
              alt="WhatsApp" 
              style={styles.icon} 
            />
 
  </a>
</div>

          </div>
        </div>
      ) : (
        <div style={styles.walletContainer}>
          <WalletComponent userDetails={userDetails} amount={amount} onClose={handleClose} />
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    minHeight: '100vh',
    backgroundColor: '#f7f7f7',
  },
  formContainer: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '500px',
    textAlign: 'center',
  },
  header: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '20px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  label: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#555',
    marginBottom: '5px',
  },
  input: {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '16px',
    width: '100%',
    boxSizing: 'border-box',
  },
  submitButton: {
    padding: '12px 25px',
    border: 'none',
    backgroundColor: '#4CAF50',
    color: '#fff',
    fontSize: '16px',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  errorMessage: {
    color: 'red',
    fontSize: '14px',
  },
  walletContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '500px',
    marginTop: '20px', // Space between the form and wallet component
  },
  helpBox: {
    marginTop: '20px',
    padding: '15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
    textAlign: 'center',
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '10px',
  },
  icon: {
    width: '50px',
    height: '50px',
    marginRight: '8px'  // Space between the image and text
  },
  link: {
    fontSize: '16px',
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: '500',
  },
};

export default Topup;
